<template>
  <v-sheet
    id="editShareFileModal"
    class="modal"
    style="display: flex"
    @click="close()"
    v-if="isShown">
    <!-- Modal content -->
    <v-sheet class="modal-content" @click.stop="">
      <div class="my-modal-header">
        <p style="font-weight: bold; font-size: 22px">Edit ShareFile Path</p>
        <span class="close" @click="close()"></span>
      </div>
      <div class="modal-body" style="padding: 0; overflow-y: auto">
        <v-progress-linear color="primary" indeterminate v-if="inProgress"></v-progress-linear>
        <div class="scollable-container" style="overflow: hidden">
          <ShareFileEditPopupRow
            v-for="item of shareFileItems"
            :key="item.name"
            :item="item"
            @select-item="selectRow"
            @update_item_selection="onUpdateItemSelection"
            @set-progress-visibility="setProgressVisibility"
            @update_expanded_node="onUpdateExpandedNode"
            @update_item_children="onUpdateItemChildren"
            :selectedfolderid="selectedShareFileId">
          </ShareFileEditPopupRow>
        </div>
      </div>
      <div class="modal-footer" style="flex-flow: row-reverse">
        <v-btn class="ml-4" color="primary" @click="saveShareFilePath()">Save</v-btn>
        <v-btn @click="close()">Close</v-btn>
      </div>
    </v-sheet>
  </v-sheet>
</template>

<script>
  import { getShareFileAccessToken, getShareFileTopFolders } from '@/scripts/js/forgeService';
  import { ShareFileItem } from '@/scripts/js/forgeModels';
  export default {
    name: 'EditShareFilePopup',
    components: {
      ShareFileEditPopupRow: () => import('./shareFileEditPopupRow.vue'),
    },
    emits: ['on-save'],
    data() {
      return {
        inProgress: false,
        shareFileItems: [],
        localSelectedFile: null,
      };
    },
    mounted() {
      this.localSelectedFile = this.selectedShareFileId;
      this.setProgressVisibility(true);
      getShareFileAccessToken((token) => {
        this.$store.state.shareFileToken = token;

        getShareFileTopFolders(token, (items) => {
          items = items.map((o) => new ShareFileItem(o.name, o.id, true, 0, null));
          items.forEach((o) => {
            o.fileSize = null;
            if (this.localSelectedFile == o.id) o.isSelected = true;
          });
          this.shareFileItems = items;
          this.setProgressVisibility(false);
        });
      });
    },
    methods: {
      selectRow(item) {
        this.shareFileItems.forEach((o) => o.setAllNotSelected());
        item.isSelected = true;
        this.localSelectedFile = item.id;
      },
      saveShareFilePath() {
        if (!this.localSelectedFile) {
          this.$dialog.notify.warning('No folder selected, please select a folder first.', {
            position: 'top-right',
            timeout: 3000,
          });
          return;
        }
        this.$emit('on-save', this.localSelectedFile);
        this.close();
      },
      close() {
        this.$store.state.shareFilePopupInfo.shown = false;
        this.$store.state.shareFilePopupInfo.id = null;
      },
      setProgressVisibility(show) {
        this.inProgress = show;
      },
      onUpdateExpandedNode(node, value) {
        node.isExpanded = value;
      },
      onUpdateItemChildren(node, value) {
        node.children = value;
      },
      onUpdateItemSelection(node, value) {
        node.isSelected = value;
      },
    },
    computed: {
      selectedShareFileId() {
        return this.$store.state.shareFilePopupInfo.id;
      },
      isShown() {
        return this.$store.state.shareFilePopupInfo.shown;
      },
    },
    watch: {
      selectedShareFileId: function (value) {
        this.shareFileItems.forEach((o) => o.setAllNotSelected());
        if (value) this.shareFileItems.forEach((o) => o.setItemSelected(value));
      },
    },
  };
</script>

<style></style>
